import { gql, QueryResult, useQuery } from "@apollo/client";

import { BrandQuery, BrandQueryResult } from "../../generated/gql/graphql";

const GET_BRANDS = gql`
  query GetBrands {
    brands {
      items {
        name
        sort
        status
        id
      }
    }
  }
`;

export default function useBrands(
  query?: BrandQuery
): QueryResult<BrandQueryResult> {
  return useQuery(GET_BRANDS, {
    variables: {
      query,
    },
  });
}
